import {Component, forwardRef, Injector, Input} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {InventoryRecipeSizeSearchModel} from "../inventory-recipe-size-search.model";
import {
    AbstractSingleSelectEditControlComponent
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-single-select-edit-control.component";

const CUSTOM_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => InventoryRecipeSizeSingleSelectEditControlComponent),
    multi: true
};

@Component({
    selector: "wbo-inventory-recipe-size-single-select-edit-control",
    templateUrl: "../../../framework/entity/edit/edit-controls/select-edit-controls/single-select-edit-control.component.html",
    providers: [CUSTOM_VALUE_ACCESSOR,
        provideSearchModel(InventoryRecipeSizeSearchModel)
    ]
})

export class InventoryRecipeSizeSingleSelectEditControlComponent extends AbstractSingleSelectEditControlComponent<InventoryRecipeSizeSearchModel> {

    constructor(model: InventoryRecipeSizeSearchModel, injector: Injector) {
        super(model, injector, "id", "size");
    }

    private _inventoryId: number;

    get inventoryId(): number {
        return this._inventoryId;
    }

    @Input()
    set inventoryId(value: number) {
        this._inventoryId = value;

        if (this._inventoryId) {
            this.model.filter["inventoryId"] = value;
            this.model.search().subscribe(() => this.data = this.model.data);
        }
    }

    private _measureId: number;

    get measureId(): number {
        return this._inventoryId;
    }

    @Input()
    set measureId(value: number) {
        this._measureId = value;

        if (!this._inventoryId && this._measureId) {
            this.model.filter["inventoryId"] = -1;
            this.model.filter["_measureId"] = value;
            this.model.search().subscribe(() => this.data = this.model.data);
        }
    }

    override click() {
        this.selectControlComponent.click();
    }
}
